module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


/*****************
 ** WEBPACK FOOTER
 ** external {"commonjs":"react","commonjs2":"react","amd":"React","root":"React"}
 ** module id = 1
 ** module chunks = 0
 **/